// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CartHeaderFlyout: React.FC<{ width?: number; height?: number; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 20 19" width={width} height={height}>
            <path
                fill="currentColor"
                d="M.56.25a.563.563 0 0 0 0 1.125h1.326a.56.56 0 0 1 .55.45l2.06 10.125a2.24 2.24 0 0 0 2.194 1.8h10.666a.563.563 0 0 0 0-1.125H6.69c-.531 0-.99-.376-1.098-.9l-.273-1.35h11.005a2.24 2.24 0 0 0 2.173-1.705l1.47-5.896a1.125 1.125 0 0 0-1.085-1.399H3.468A1.675 1.675 0 0 0 1.886.25zM3.713 2.5h15.165l-1.466 5.9c-.126.498-.574.85-1.088.85H5.088zm2.166 13.781a.841.841 0 1 1 1.68 0 .84.84 0 0 1-.84.844.84.84 0 0 1-.84-.844m2.799 0a1.97 1.97 0 0 0-.98-1.705 1.95 1.95 0 0 0-1.96 0 1.97 1.97 0 0 0-.98 1.705c0 .704.374 1.354.98 1.705a1.95 1.95 0 0 0 1.96 0 1.97 1.97 0 0 0 .98-1.705m6.998-.843c.464 0 .84.377.84.843a.84.84 0 0 1-.84.844.84.84 0 0 1-.84-.844c0-.466.377-.843.84-.843m0 2.812c.7 0 1.347-.375 1.697-.984.35-.61.35-1.36 0-1.97a1.96 1.96 0 0 0-1.697-.983c-.7 0-1.347.375-1.697.984s-.35 1.36 0 1.969.997.984 1.697.984"
            />
        </svg>
    );
};

export default React.memo(CartHeaderFlyout);
